<template>
  <form
    class="discover-email-form"
    data-testid="discover-email-form"
    @submit.prevent="onContinue"
  >
    <header class="discover-email-form__header">
      <h1 class="discover-email-form__title" data-testid="discover-email-form__title">
        {{ copy.SIGN_IN_HEADING }}
      </h1>
      <p class="discover-email-form__subtitle" data-testid="discover-email-form__subtitle">
        {{ copy.DISCOVER_SUBTITLE }}
      </p>
    </header>
    <AuthLoginAlert :message="bannerMessage" />
    <div class="discover-email-form__fields">
      <div class="discover-email-form__field">
        <label class="discover-email-form__label" for="discover-email-input">
          {{ copy.WORK_EMAIL_LABEL }}
        </label>
        <input
          id="discover-email-input"
          v-model="emailLocal"
          class="discover-email-form__input"
          :class="{ 'discover-email-form__input--error': Boolean(emailError) }"
          type="email"
          name="email"
          autocomplete="username"
          :placeholder="copy.WORK_EMAIL_PLACEHOLDER"
          :aria-invalid="Boolean(emailError)"
          :aria-describedby="emailError ? 'discover-email-error' : null"
          :disabled="loading"
          data-testid="discover-email-form__email"
        />
        <p
          v-if="emailError"
          id="discover-email-error"
          class="discover-email-form__field-error"
          role="alert"
          data-testid="discover-email-form__email-error"
        >
          {{ emailError }}
        </p>
      </div>
      <v-btn
        class="discover-email-form__continue"
        color="primary"
        block
        large
        elevation="0"
        type="submit"
        :disabled="!emailLocal || loading"
        data-testid="discover-email-form__continue"
      >
        <span>{{ copy.CONTINUE }}</span>
      </v-btn>
    </div>
  </form>
</template>

<script>
import constants from '../../../plugins/constants';
import AuthLoginAlert from './AuthLoginAlert.vue';

const { AUTH } = constants;

export default {
  name: 'DiscoverEmailForm',
  components: {
    AuthLoginAlert,
  },
  props: {
    email: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    alertMessage: { type: String, default: '' },
  },
  data() {
    return {
      emailLocal: this.email || '',
      copy: AUTH,
    };
  },
  computed: {
    emailError() {
      return this.alertMessage === this.copy.GENERIC_DISCOVER_ERROR
        ? this.alertMessage
        : '';
    },
    bannerMessage() {
      return this.emailError ? '' : this.alertMessage;
    },
  },
  watch: {
    email(value) {
      this.emailLocal = value || '';
    },
  },
  beforeDestroy() {
    this.emailLocal = '';
  },
  methods: {
    onContinue() {
      if (!this.emailLocal || this.loading) return;
      this.$emit('continue', this.emailLocal);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './DiscoverEmailForm.scss';
</style>
